'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getFacetIds = exports.getItemSavedSearchType = exports.getItemSavedSearchQuery = undefined;

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCategoryName(facet) {
    var categoryId = facet.categoryId;


    if (categoryId === facet.l1CategoryId) {
        return facet.l1CategoryName;
    } else if (categoryId === facet.l2CategoryId) {
        return facet.l2CategoryName;
    } else if (categoryId === facet.l3CategoryId) {
        return facet.l3CategoryName;
    } else if (categoryId === facet.l4CategoryId) {
        return facet.l4CategoryName;
    }
}

function processFacets(facets) {
    /*
    * Order of Precedence for Search Alert
    * [creator + category]
    * [material + category]
    * [style + category]
    * [origin + category]
    * [origin + material]
    * [category]
    */
    var searchQuery = { keyword: '' };
    var searchType = '';

    if ((0, _isEmpty2.default)(facets)) return { searchQuery: searchQuery, searchType: searchType };
    var categories = facets.categories,
        creators = facets.creators,
        materialsTechniques = facets.materialsTechniques,
        origins = facets.origins,
        stylePeriods = facets.stylePeriods;


    if (creators.length && categories.length) {
        var ids = creators[0].l1CategoryId + ',' + categories[0].categoryId;

        searchQuery.category_id = ids;
        searchType = creators[0].l1CategoryName + ' ' + getCategoryName(categories[0]);
    } else if (materialsTechniques.length && categories.length) {
        var _ids = materialsTechniques[0].l1CategoryId + ',' + categories[0].categoryId;

        searchQuery.category_id = _ids;
        searchType = materialsTechniques[0].l1CategoryName + ' ' + getCategoryName(categories[0]);
    } else if (stylePeriods.length && categories.length) {
        var _ids2 = stylePeriods[0].l1CategoryId + ',' + categories[0].categoryId;

        searchQuery.category_id = _ids2;
        searchType = stylePeriods[0].l1CategoryName + ' ' + getCategoryName(categories[0]);
    } else if (origins.length && categories.length) {
        var _ids3 = origins[0].categoryId + ',' + categories[0].categoryId;

        searchQuery.category_id = _ids3;
        searchType = getCategoryName(origins[0]) + ' ' + getCategoryName(categories[0]);
    } else if (origins.length && materialsTechniques.length) {
        var _ids4 = origins[0].categoryId + ',' + materialsTechniques[0].l1CategoryId;

        searchQuery.category_id = _ids4;
        searchType = getCategoryName(origins[0]) + ' ' + materialsTechniques[0].l1CategoryName;
    } else if (categories.length) {
        var _ids5 = '' + categories[0].categoryId;

        searchQuery.category_id = _ids5;
        searchType = '' + getCategoryName(categories[0]);
    }

    return { searchQuery: searchQuery, searchType: searchType };
}

var getItemSavedSearchQuery = exports.getItemSavedSearchQuery = function getItemSavedSearchQuery(facets) {
    var _processFacets = processFacets(facets),
        searchQuery = _processFacets.searchQuery;

    return searchQuery;
};

var getItemSavedSearchType = exports.getItemSavedSearchType = function getItemSavedSearchType(facets) {
    var _processFacets2 = processFacets(facets),
        searchType = _processFacets2.searchType;

    return searchType;
};

var getFacetIds = exports.getFacetIds = function getFacetIds(facets) {
    var ids = [];
    if ((0, _isEmpty2.default)(facets)) return ids;

    var categories = facets.categories,
        creators = facets.creators,
        materialsTechniques = facets.materialsTechniques,
        origins = facets.origins,
        stylePeriods = facets.stylePeriods;

    if (categories.length) {
        ids.push(categories[0].categoryId);
    }
    if (creators.length) {
        ids.push(creators[0].l1CategoryId);
    }
    if (materialsTechniques.length) {
        ids.push(materialsTechniques[0].l1CategoryId);
    }
    if (origins.length) {
        ids.push(origins[0].categoryId);
    }
    if (stylePeriods.length) {
        ids.push(stylePeriods[0].l1CategoryId);
    }
    return ids;
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Item/ItemPageUtils.js
// module id = VWZ9
// module chunks = 57